export const setupVideoUploadWorker = (
  signedUrl: string,
  file: File,
  onMessage: (event: MessageEvent<{ success: boolean; error?: Error }>) => void,
) => {
  const videoUploadWorker = new Worker(new URL('../workers/videoFileUploadWorker.js', import.meta.url));

  videoUploadWorker.onmessage = onMessage;

  videoUploadWorker.postMessage({
    url: signedUrl,
    file,
  });

  return videoUploadWorker;
};
